import { Button } from 'antd';
import { COLORS, computeRemSize } from '@ydistri/theme';
import { css, styled } from 'styled-components';

export const RulesSectionContainer = styled.div`
  width: 100%;
  max-width: ${computeRemSize(900)};
`;

export const RuleSets = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${computeRemSize(10)};
`;

export const RuleSetCard = styled.div<{ $hasWarning?: boolean }>`
  border: 1px solid ${COLORS.BORDER};
  border-left: ${computeRemSize(3)} solid ${COLORS.PRIMARY};
  background-color: ${COLORS.GREY_LIGHT};

  ${({ $hasWarning }) =>
    $hasWarning &&
    css`
      background-color: ${COLORS.TABLE_HIGHLIGHT_ORANGE};
    `}
`;

export const RuleSetHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${computeRemSize(8)};
  padding: ${computeRemSize(8)} ${computeRemSize(12)} 0;
`;

export const RuleSetNumber = styled.span`
  color: ${COLORS.PRIMARY_DARK};
  font-size: ${computeRemSize(12)};
  font-weight: 600;
  text-transform: uppercase;
`;

export const RuleSetHint = styled.span`
  color: ${COLORS.GREY};
  font-size: ${computeRemSize(12)};
`;

export const RemoveRuleSetButton = styled(Button)`
  margin-left: auto;
`;

export const AddRuleSetButton = styled(Button)`
  min-width: ${computeRemSize(220)};
`;

export const RuleSetGuidanceList = styled.ul`
  margin: 0;
  padding-left: ${computeRemSize(24)};
  font-size: ${computeRemSize(12)};
  line-height: 1.5;
`;

export const RuleSetWarning = styled.li`
  color: ${COLORS.DANGER};
`;

export const RuleSetsFooter = styled.div<{ $hasContent: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $hasContent }) => ($hasContent ? 'space-between' : 'center')};
  gap: ${computeRemSize(12)};
`;
